import {
  ensureDisplayImageUrls,
  isLoadableDisplayPreviewUrl,
  isManagedStorageUrl,
  isSignedDisplayUrl,
  warmDisplayCacheFromRecords,
} from '@/utils/imageDisplayAccess';
import { resolveCropResultTiles } from './imageCropDetailPrints';
import { resolveImageCropOriginalTileDisplayUrl } from './imageCropReferencePreview';

function pushWarmRecord(records, seen, canonical, display = '') {
  const raw = String(canonical || '').trim();
  if (!raw || seen.has(raw)) return;
  seen.add(raw);
  const disp = String(display || '').trim();
  // 禁止把过期签名 / 临时外链预热进 displayCache（原图裂图主因之一）
  const safeDisplay = disp && isLoadableDisplayPreviewUrl(disp) ? disp : '';
  records.push({
    url: raw,
    displayUrl: safeDisplay || undefined,
    viewUrl: safeDisplay || undefined,
  });
}

/** 从详情行收集需预热签名缓存的图片记录 */
export function collectImageCropDisplayWarmRecords(rows = [], referencePreviewByImageId = new Map()) {
  const records = [];
  const seen = new Set();

  (rows || []).forEach((row) => {
    const imageId = String(row?.imageId || '');
    const original = String(row?.originalUrl || '').trim();
    if (original) {
      const refPreview = referencePreviewByImageId.get(imageId) || '';
      const display = resolveImageCropOriginalTileDisplayUrl(row, refPreview);
      // 仅当 canonical 为受管路径时预热；外链 https 不进 sign-batch
      if (isManagedStorageUrl(original) && !isSignedDisplayUrl(original)) {
        pushWarmRecord(records, seen, original, display);
      } else if (display && isSignedDisplayUrl(display)) {
        // 无受管 canonical 时，不把临时外链写入 cache key
      }
    }

    resolveCropResultTiles(row).forEach((tile) => {
      if (tile?.url) {
        pushWarmRecord(records, seen, tile.url, tile.displayUrl);
      }
    });

    const cropped = String(row?.croppedUrl || '').trim();
    if (cropped) {
      pushWarmRecord(records, seen, cropped, row?.croppedDisplayUrl);
    }
  });

  return records;
}

/** 详情页数据到达后批量预热 sign-batch 缓存，避免 SignedImage 长期停在灰占位 */
export function warmImageCropDetailDisplayCache(rows = [], referencePreviewByImageId = new Map()) {
  const records = collectImageCropDisplayWarmRecords(rows, referencePreviewByImageId);
  if (!records.length) return Promise.resolve();

  warmDisplayCacheFromRecords(records, (item) => item.url);

  const needSign = [...new Set(
    records
      .map((item) => item.url)
      .filter((url) => url && isManagedStorageUrl(url) && !isSignedDisplayUrl(url)),
  )];
  if (!needSign.length) return Promise.resolve();
  return ensureDisplayImageUrls(needSign);
}
